import React, { useEffect } from "react";
import { withRouter } from "react-router";
import classnames from "classnames";
import { connect } from "react-redux";

import * as actions from "../../../../store/actions";
import { getOnboardingPath, NO_DATA_FOUND } from "../../../../constants";

import Button from "../../../../components/formElements/button/Button";
import TextInput from "../../../../components/formElements/input/TextInput";
import Row from "../../../../components/uiElements/grid/Row";
import Card from "../../../../layout/Onboarding/Card";
import Col from "../../../../components/uiElements/grid/Col";
import OnboardingIcon from "../../../../components/uiElements/icons/onboardingIcons/OnboardingIcon";

const StepFive = ({
  redirectedPath,
  accountDetails,
  history,
  getBankDetailsForPhysician,
  addBankDetailsForPhysician,
  updateBankDetailsForPhysician,
  updateDoctorStatus,
}) => {
  useEffect(() => {
    getBankDetailsForPhysician();
    // eslint-disable-next-line
  }, []);

  const { bankDetails } = accountDetails;

  return (
    <>
      <div className={classnames("onboarding-container")}>
        <p className="onboarding-header">Bank Details</p>
        <Row>
          <Card>
            <Row
              className={classnames(
                "mb-5",
                bankDetails ? "disable mt-n5" : "mt-n5"
              )}
              style={{
                minHeight: 200,
              }}
            >
              {bankDetails ? (
                <>
                  <p className="pl-3 mt-2">
                    Status:{" "}
                    <span className="badge badge-primary mb-2">
                      {bankDetails?.status?.toUpperCase()}
                    </span>
                  </p>
                  <Col size={["md-12"]} className="mt-4 mb-n4">
                    <TextInput
                      type="text"
                      label="Bank Name"
                      value={bankDetails?.bank_name}
                    />
                  </Col>
                  <Col size={["md-12"]} className="mt-4 mb-n4">
                    <TextInput
                      type="text"
                      label="Account Number"
                      value={"xxx xxx xxx " + bankDetails?.last4}
                    />
                  </Col>
                  <Col size={["md-12"]} className="mt-3 mb-n5">
                    <TextInput
                      type="number"
                      maxLength={9}
                      label="Routing Number"
                      value={bankDetails?.routing_number}
                    />
                  </Col>
                </>
              ) : (
                <>
                  <div className="mx-auto mt-0 pt-0">
                    <p className="content-center m-auto not-found-image">
                      <img
                        src={NO_DATA_FOUND}
                        width={366}
                        height={300}
                        alt="requests-not-found"
                      />
                    </p>
                    <p className="text-center"> No bank details found.</p>
                  </div>
                </>
              )}
            </Row>
          </Card>
          {!bankDetails && (
            <Button
              type="info"
              className={classnames("w-75 ml-5 mb-4")}
              label={"Create"}
              onClick={() =>
                addBankDetailsForPhysician(url => {
                  localStorage.setItem("bankRedirect", true);
                  window.open(url, "_self");
                })
              }
            />
          )}
          {bankDetails && redirectedPath && (
            <Button
              type="info"
              className={classnames("w-75 ml-5 mb-4")}
              label={"Update"}
              onClick={() =>
                updateBankDetailsForPhysician(bankDetails?.account, url =>
                  window.open(url, "_self")
                )
              }
            />
          )}
          {!redirectedPath && (
            <Button
              type="secondary"
              indicatorButton
              className={classnames("float-right next-button")}
              label={<OnboardingIcon type="nextButton" />}
              disabled={!bankDetails}
              onClick={() => {
                history.push(getOnboardingPath("/dosespot"));
              }}
            />
          )}
        </Row>
      </div>
    </>
  );
};

const mapStoreToProps = ({ onboarding, auth }) => ({
  accountDetails: onboarding?.accountDetails,
  redirectedPath: auth.redirectToOnboardingPath,
});

const mapDispatchToProps = dispatch => ({
  getBankDetailsForPhysician: () =>
    dispatch(actions.getBankDetailsForPhysician()),
  addBankDetailsForPhysician: cb =>
    dispatch(actions.addBankDetailsForPhysician(cb)),
  updateBankDetailsForPhysician: (id, cb) =>
    dispatch(actions.updateBankDetailsForPhysician(id, cb)),
  updateDoctorStatus: (payload, cb) =>
    dispatch(actions.updateDoctorStatus(payload, cb)),
});

export default withRouter(
  connect(mapStoreToProps, mapDispatchToProps)(StepFive)
);
